import { render, staticRenderFns } from "./RequestAudit.vue?vue&type=template&id=a70add90&"
import script from "./RequestAudit.vue?vue&type=script&lang=js&"
export * from "./RequestAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports